import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import referralService from '../../../services/referral';
import { StyledTheme } from '../../../styles/styleTheme';
import { getDocumentReferralTabUrl } from '../../document/utils/navigationHelpers';

interface OpenReferralLinkProps {
  /** The task's saved CRM lead id, not the field being edited, so typing does not refetch. */
  crmId?: string | null;
}

/**
 * From an eligibility task back to its referral, resolved through the CRM lead id both
 * systems share. One lookup, on the task detail page only, never per row of the task list.
 *
 * Renders nothing while it resolves, when the lead has no referral, and when the caller may
 * not see it (leads-api scopes documents to the caller's clinics, or answers 403).
 */
const OpenReferralLink: React.FC<OpenReferralLinkProps> = ({ crmId }) => {
  const [documentId, setDocumentId] = useState<number | null>(null);

  useEffect(() => {
    setDocumentId(null);
    if (!crmId) {
      return;
    }

    let active = true;
    referralService
      .findReferralDocumentByCrmId(crmId)
      .then((match) => {
        if (active) {
          setDocumentId(match?.documentId ?? null);
        }
      })
      // The link is a convenience: any failure just leaves it hidden.
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, [crmId]);

  if (!documentId) {
    return null;
  }

  return (
    <Button
      variant='contained'
      component={RouterLink}
      to={getDocumentReferralTabUrl(documentId)}
      style={{ background: StyledTheme.tealDark }}
      fullWidth
      startIcon={<AssignmentIndIcon color='inherit' />}>
      Open referral
    </Button>
  );
};

export default OpenReferralLink;
